import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { trustPilotBusinessIdPerMarket } from '~/constants/markets';
import { generateLocale } from '~/helpers/generators.helper';
import { RootState } from '~/store';

const DEFAULT_TRUSTPILOT_TEMPLATE_ID = '5419b6ffb0d04a076446a9af';

interface TrustpilotWidgetProps {
  templateId?: string;
}

const TrustpilotWidget = ({
  templateId = DEFAULT_TRUSTPILOT_TEMPLATE_ID,
}: TrustpilotWidgetProps) => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = useRef(null);

  const { language, market } = useSelector((state: RootState) => state.intl);

  const locale = generateLocale(language, market);

  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, [language]);

  useEffect(() => {
    const script = document.createElement('script');
    document.body.appendChild(script);
    script.src =
      '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
  }, []);

  return (
    <div
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id={templateId}
      data-businessunit-id={trustPilotBusinessIdPerMarket[market]}
      data-style-height="20px"
      data-style-width="100%"
      data-theme="light"
      data-testid="trustpilot-widget"
    />
  );
};
export default TrustpilotWidget;
